import { Injectable } from "@angular/core";
import { FocusFieldStrategy } from "../directives/navigation-section.directive";
import { BaseNavigationStrategyService } from "./base-navigation-strategy.service";
import { NavigationService } from "./navigation.service";

@Injectable()
export class HorizontalNavigationStrategy extends BaseNavigationStrategyService {
    handleKeyPress(event: KeyboardEvent): void {
        if (NavigationService.LEFT_KEY.includes(event.keyCode)) { //sinistra
            if (this.isFirstOrUniqueFieldOfActiveSection()) {
                this.moveToPreviousSection(FocusFieldStrategy.Last);
            } else {
                this.moveToPreviousField(event);
            }
        } else if (NavigationService.RIGHT_KEY.includes(event.keyCode)) { //destra
            if (this.isLastOrUniqueFieldOfActiveSection()) {
                this.moveToNextSection(FocusFieldStrategy.First);
            } else {
                this.moveToNextField(event);
            }
        }
    }
}
